import type { ReactNode } from "react";
import type { TabItem } from "@/components/Misc/Tabs";

export type AccordionType = {
  name: string;
  title: string;
  isOpen: boolean;
  content: ReactNode;
};

export type TimePeriod = { value: number | string | null; label: string };

export const TREND_TABS: Array<TabItem> = [
  { value: "outages", label: "Avbrudd", measurement: undefined },
  { value: "downtime", label: "Utetid", measurement: "min" },
  { value: "kile", label: "KILE", measurement: "kr" },
  { value: "saidi", label: "SAIDI", measurement: "min/bruker" },
];

/** Oppdeling (stacking) options for the Tilstandstrend chart. "none" = single total area. */
export const STATE_TREND_OPPDELING: Array<{ value: string; label: string }> = [
  { value: "none", label: "Ingen" },
  { value: "is_deviation", label: "Strategiavvik" },
  { value: "system", label: "System" },
  { value: "zone", label: "Økonomisk sone" },
  { value: "state", label: "Tilstand" },
  { value: "component", label: "Komponent" },
  { value: "ip_type", label: "Kontrollpunkt" },
];

export const TIME_PERIODS: Array<TimePeriod> = [
  { value: "fortnight", label: "Siste to uker" },
  { value: "month", label: "Siste måned" },
  { value: "year", label: "Siste 12 måneder" },
  { value: "5years", label: "Siste 5 år" },
  { value: "total", label: "Totalt" },
];

export const TIME_PERIODS_TREND: TimePeriod[] = [
  { value: 12, label: "12 måneder" },
  { value: 24, label: "24 måneder" },
  { value: 36, label: "36 måneder" },
  { value: 48, label: "48 måneder" },
  // FIXME: these need a refactor
  // 12 months is 12 months from _last upload_, it is probably actually confusing to show "hittil i år"
  { value: "hittil i år", label: "Hittil i år" },
  { value: null, label: "Totalt" },
];
